import { FC } from 'react';

import { css, styled } from '@mui/material/styles';

import { Text } from 'components/UIkit/atoms/Text';

interface EditOptionButtonProps {
  onClick: (e: React.MouseEvent) => void;
  customText?: string;
  variant?: 'primary' | 'secondary';
}

export const EditOptionButton: FC<EditOptionButtonProps> = ({
  onClick,
  customText = 'EDIT',
  variant = 'primary'
}) => {
  return (
    <StyledEditButton onClick={onClick} variant={variant}>
      <Text variant="button-small" color="primary">
        {customText}
      </Text>
    </StyledEditButton>
  );
};

const StyledEditButton = styled('div')<{ variant: 'primary' | 'secondary' }>(
  ({ theme, variant }) => css`
    cursor: pointer;
    color: ${variant === 'secondary' ? theme.palette.secondary.dark : theme.palette.primary.main};
    &:hover {
      opacity: 0.8;
    }
  `
);
